'use client';
import { Link } from '@mui/material';
import { styled } from '@mui/material/styles';

export const SecondaryLink = styled(Link)(({ theme }) => {
  const { primary } = theme.palette;

  return {
    alignItems: 'center',
    appearance: 'button',
    backgroundColor: primary.contrastText,
    borderColor: primary.main,
    border: '1px solid',
    borderRadius: '0.125rem',
    color: primary.main,
    display: 'flex',
    gap: '0.5rem',
    justifyContent: 'center',
    minWidth: '10rem',
    padding: '0.8rem 0',
    textDecoration: 'none',
    textTransform: 'uppercase',
    touchAction: 'manipulation',
    transition: 'background-color .15s ease-out',
    userSelect: 'none',
    whiteSpace: 'nowrap',
    '&:hover': {
      textDecoration: 'none',
      color: primary.main,
      backgroundColor: primary.contrastText,
    },
    '&:focus': {
      color: primary.main,
    },
  };
});
